const styles = {
  topBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "50px",
    backgroundColor: "var(--surface)",
    color: "var(--text)",
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    padding: "0 16px", // lateral gutter, matching the cards
    boxSizing: "border-box",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.3)",

    zIndex: 1100,
  },
  centerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flex: 1, // Allows it to take up available space
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
    minWidth: "0", // Prevent overflow in center when left or right are larger
  },
  leftContainer: {
    minWidth: "50px", // Minimum width for left container
    textAlign: "left", // Align left content
  },
  rightContainer: {
    minWidth: "50px", // Minimum width for right container
    textAlign: "right", // Align right content
  },
};

export default styles;
